module.exports = __webpack_public_path__ + "img/Users.ffe6ae05.jpg";